import React, { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export class RecommendationHistoryHeader extends PureComponent {
  static propTypes = {
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    navigateBack: PropTypes.func.isRequired,
  }

  render() {
    const {
      i18n, navigateBack,
    } = this.props;

    return (
      <div className={classNames('recommendation-history-header')} >
        <div className="recommendation-navigate-back-ground">
          <button
            className="recommendation-navigate-back btn-link"
            onClick={navigateBack}
          >
            <span className={classNames('iconba', 'iconba-Back')} />
            <span className="recommendation-navigate-back-text">
              {i18n.getString('Back_To_Recommendation')}
            </span>
          </button>
        </div>
        <h4 className="recommendation-history-title">
          {i18n.getString('Apply_History')}
        </h4>
        <div className="recommendation-history-pitching">
          {i18n.getString('Apply_History_Explanation')}
        </div>
      </div>
    );
  }
}
